/* ============================================================================
 * freebie-picker.js
 * ----------------------------------------------------------------------------
 * Klick auf eine Freebie-Kachel im Warenkorb-Drawer:
 *   1. Variante per Shopify.addItem in den Warenkorb legen
 *   2. Drawer-Inhalt serverseitig neu holen (/cart?view=ajax_side_cart)
 *      -> dadurch rechnet snippets/freebie-picker.liquid Stufen, Zaehler und
 *         gesperrte Kacheln automatisch neu. Kein Zustand im JavaScript.
 *   3. Warenkorb-Zaehler im Header aktualisieren
 *
 * Gegenstueck: snippets/freebie-picker.liquid
 * ========================================================================== */
(function ($) {
  'use strict';

  if (!$) return;

  var WRAPPER = '#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper';
  var BUSY    = 'freebie-busy';

  function root() {
    if (window.routes && window.routes.root) return window.routes.root;
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function url(path) {
    return (root() + path).replace(/\/{2,}/g, '/');
  }

  /* Genau der Aufruf, den auch halo.updateSidebarCart macht */
  function refreshDrawer() {
    return $.ajax({
      type: 'GET',
      url: url('cart?view=ajax_side_cart'),
      cache: false
    }).then(function (data) {
      $(WRAPPER).html($(data));
      $(document).trigger('freebie:drawer-updated');
    });
  }

  function refreshCount() {
    return $.ajax({
      type: 'GET',
      url: url('cart.js'),
      cache: false,
      dataType: 'json'
    }).then(function (cart) {
      var strings = window.cartStrings || {};
      $('[data-cart-count]').text(cart.item_count >= 100 ? (strings.item_99 || '99+') : cart.item_count);
      if (strings.item && strings.items) {
        $('[data-cart-text]').text(cart.item_count === 1 ? strings.item : strings.items);
      }
    });
  }

  function showError($picker, message) {
    var $box = $picker.find('[data-freebie-error]');
    if (!$box.length) return;
    $box.text(message).prop('hidden', false);
  }

  /* Bewusst NICHT Shopify.addItem aus global.js: dessen Error-Handler greift
     auf einen optionalen Parameter zu (input.length) und wirft, wenn er fehlt,
     und der Default-Callback ist ein alert(). Der direkte POST ist kuerzer und
     hat sauberes Fehlerverhalten.

     Der Kunde hat immer nur EIN Freebie. Liegt schon eines im Korb, wird in
     einem einzigen Request getauscht: alte Zeile auf 0, neue auf 1. Dadurch
     kann nie ein Zwischenzustand mit zwei Gratis-Pflanzen entstehen. */
  function chooseVariant(variantId, currentIds) {
    if (!currentIds.length) {
      return $.ajax({
        type: 'POST',
        url: url('cart/add.js'),
        dataType: 'json',
        data: { id: variantId, quantity: 1 }
      });
    }

    var updates = {};
    currentIds.forEach(function (id) { updates[id] = 0; });
    updates[variantId] = 1;

    return $.ajax({
      type: 'POST',
      url: url('cart/update.js'),
      dataType: 'json',
      data: { updates: updates }
    });
  }

  $(document).on('click', '[data-freebie-add]', function (event) {
    event.preventDefault();
    event.stopPropagation();

    var $btn    = $(this);
    var $picker = $btn.closest('[data-freebie-picker]');
    var id      = $btn.attr('data-variant-id');
    var current = ($picker.attr('data-freebie-current') || '')
                    .split(',')
                    .filter(function (s) { return s && s !== id; });

    if (!id || $btn.is('[disabled]') || $picker.data(BUSY)) return;

    $picker.data(BUSY, true);
    $picker.find('[data-freebie-error]').prop('hidden', true);
    $btn.addClass('is-loading');
    $picker.find('[data-freebie-add]').prop('disabled', true);

    Promise.resolve(chooseVariant(id, current))
      .then(function () { return Promise.all([refreshDrawer(), refreshCount()]); })
      .catch(function (xhr) {
        /* 422 = Shopify lehnt ab, meist inzwischen ausverkauft. Drawer neu
           laden, damit die Kachel verschwindet, dann Hinweis anzeigen. */
        var soldOut = xhr && xhr.status === 422;
        return Promise.resolve(refreshDrawer()).catch(function () {}).then(function () {
          var $p = $('[data-freebie-picker]');
          if (soldOut) {
            showError($p, 'Diese Pflanze ist leider gerade vergriffen. Bitte wähle eine andere.');
          } else {
            $btn.removeClass('is-loading');
            $p.find('[data-freebie-add]').prop('disabled', false);
            showError($p, 'Das hat nicht geklappt. Bitte versuche es noch einmal.');
          }
        });
      })
      .then(function () {
        /* Nach erfolgreichem Refresh ist das Markup ersetzt - nichts mehr
           aufzuraeumen. Das Flag zurueckzusetzen schadet trotzdem nicht. */
        $picker.data(BUSY, false);
      });
  });
})(window.jQuery);
